import { useMemo } from "react"
import { useQuery } from "urql"

import "../graphql/queries"

import type { AccountingSettings } from "@/graphql/codegen/graphql"
import { GetAccountingSettingsDocument } from "@/graphql/codegen/graphql"

interface UseGetAccountingSettingsReturn {
  settings: AccountingSettings | undefined
  isFetching: boolean
}

export const useGetAccountingSettings = (): UseGetAccountingSettingsReturn => {
  const [{ data, fetching }] = useQuery({ query: GetAccountingSettingsDocument })

  const settings = useMemo<AccountingSettings | undefined>(() => {
    const result = data?.accountingSettings.get
    if (result?.__typename === "AccountingSettingsGetSuccess") {
      return result.settings
    }
    return undefined
  }, [data])

  return { settings, isFetching: fetching }
}
